/* eslint-disable camelcase */
import React from 'react';
import moment from 'moment';
import palette from '@telus-uds/palette-allium/build/web/palette';

const { colorAccessibleGreen, colorTelusPurple } = {
  colorAccessibleGreen: palette.color.greenAccessible,
  colorTelusPurple: palette.color.purpleTelus
};
import { Typography } from '@telus-uds/components-web';
import {Box} from '../design/css';

const OrderComments = data => {
  if (!(data && data.length)) return null;

  return data.map (comment => {
    const {text, createdAt, user: {first_name, last_name}} = comment;
    return (
      text &&
      <Box>
        <Typography
          variant={{ bold: true, colour: 'brand' }}
        >{`${first_name.concat (' ', last_name)} : `}</Typography>
        <Typography variant={{ weight: 'medium' }}>{`${text} - `}</Typography>
        <Typography variant={{ bold: true, colour: 'positive' }}>
          {moment (createdAt).format ('dddd, MMMM Do YYYY, h:mm:ss a')}
        </Typography>

      </Box>
    );
  });
};

export default OrderComments;
